"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowArtistPopoverRow_artist",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalID",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "image",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "height",
        "value": 45
      }, {
        "kind": "Literal",
        "name": "width",
        "value": 45
      }],
      "concreteType": "CroppedImageUrl",
      "kind": "LinkedField",
      "name": "cropped",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }],
      "storageKey": "cropped(height:45,width:45)"
    }],
    "storageKey": null
  }],
  "type": "Artist"
};
node.hash = 'd84437134bc4bd985ba4e09cb554e080';
var _default = node;
exports.default = _default;
//# sourceMappingURL=FollowArtistPopoverRow_artist.graphql.js.map